<template>
  <div class="energy-efficiency__wrap">
    <h5>CO2-Klasse (WLTP)</h5>
    <p class="car-details-text">
      Auf Grundlage der CO2- Emissionen <span v-if="!plugin_hybrid_extended">(kombiniert)</span>
    </p>
    <div class="energy-efficiency">
      <div
        :class="[
          'efficiency-graph',
          `active-class-${efficiencyClass.toLowerCase()}`,
          `${!!batteryEfficiencyClass ? 'active-battery-class-'+batteryEfficiencyClass.toLowerCase() : ''}`,
          `${!!batteryEfficiencyClass ? 'hybrid' : ''}`
        ]"
      >
        <div class="subtitles" v-if="batteryEfficiencyClass">
					<span class="column-class">
						gewichtet, kombiniert
					</span>
					<span class="column-class-battery">
						bei entladener Batterie
					</span>
				</div>
        <h6 class="efficiency-class efficiency-a">A</h6>
        <h6 class="efficiency-class efficiency-b">B</h6>
        <h6 class="efficiency-class efficiency-c">C</h6>
        <h6 class="efficiency-class efficiency-d">D</h6>
        <h6 class="efficiency-class efficiency-e">E</h6>
        <h6 class="efficiency-class efficiency-f">F</h6>
        <h6 class="efficiency-class efficiency-g">G</h6>
        <h6 class="efficiency-class efficiency-class-selected">
          {{ efficiencyClassLabelMap[efficiencyClass] }}
        </h6>
        <h6 class="efficiency-class efficiency-class-battery-selected" v-if="batteryEfficiencyClass">
          {{ efficiencyClassLabelMap[batteryEfficiencyClass] }}
        </h6>
      </div>
    </div>
    <p class="energy-efficiency__note">
      *Weitere Informationen zum offiziellen Kraftstoffverbrauch und den
      offiziellen spezifischen CO2-Emissionen neuer Personenkraftwagen können
      dem »Leitfaden über den Kraftstoffverbrauch, die CO2-Emissionen und den
      Stromverbrauch neuer Personenkraftwagen « entnommen werden, der an allen
      Verkaufsstellen und bei der Deutschen Automobil Treuhand GmbH unter
      www.dat.de unentgeltlich erhältlich ist.
    </p>
  </div>
</template>

<script>
export default {
  props: ['efficiency-class', 'battery-efficiency-class', 'plugin_hybrid_extended'],
  data() {
    return {
      efficiencyClassLabelMap : {
        ATriplePlus: 'A+++',
        ADoublePlus: 'A++',
        APlus: 'A+',
        A: 'A',
        B: 'B',
        C: 'C',
        D: 'D',
        E: 'E',
        F: 'F',
        G: 'G',
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// Energy efficiency graph colors
$efficiency-a-color: #02A753;
$efficiency-b-color: #48B83F;
$efficiency-c-color: #BFD62F;
$efficiency-d-color: #FFEF03;
$efficiency-e-color: #FDB812;
$efficiency-f-color: #F46F22;
$efficiency-g-color: #EC1C28;
$efficiency-selected-color: #000;

.energy-efficiency {
  max-width: 420px;
  padding-top: 27px;

  @media (min-width: 992px) {
		margin-right: 50px;
	}

  .car-details-text {
    margin-bottom: 15px;
    color: initial;
  }
  &__wrap {
    h5 {
      padding: 1.25rem 0 0.9375rem;
      font-size: 1rem;
      font-weight: 700;
    }
    .energy-efficiency__note {
      margin: 1.5rem 0 1.25rem;
      font-size: 0.75rem;
      line-height: 1rem;
    }
  }
}

.efficiency-graph {
  position: relative;
  
  &.hybrid {
    margin-top:35px;

    &:before {
      right: 22%;
      top: 0;
      content: "";
      display: block;
      width: 1px;
      height: 100%;
      position: absolute;
      background-color: #000;
    }
  }

	.subtitles {
		position:absolute;
		top:-35px;
		width: 100%;
		display:flex;
		justify-content: flex-end;

		& > span {
			color: gray;
			font-size: 12px;
			line-height: 14px;
			display:block;
			width: 15%;
			position:absolute;
			right:0;

			&:first-of-type {
				right: 25%;
			}

			&:last-of-type {
				width: 20%;
			}
		}
	}
  &.active-class-b .efficiency-class-selected { top: 19px; }
  &.active-class-c .efficiency-class-selected       { top: calc( 19px * 2 ); }
  &.active-class-d .efficiency-class-selected           { top: calc( 19px * 3 ); }
  &.active-class-e .efficiency-class-selected           { top: calc( 19px * 4 ); }
  &.active-class-f .efficiency-class-selected           { top: calc( 19px * 5 ); }
  &.active-class-g .efficiency-class-selected           { top: calc( 19px * 6 ); }
  // &.active-class-g .efficiency-class-selected           { top: calc( 19px * 7 )}
  // &.active-class-f .efficiency-class-selected           { top: calc( 19px * 8 )}
  // &.active-class-g .efficiency-class-selected           { top: calc( 19px * 9 )}


  &.active-battery-class-b .efficiency-class-battery-selected { top: 19px; }
  &.active-battery-class-c .efficiency-class-battery-selected       { top: calc( 19px * 2 ); }
  &.active-battery-class-d .efficiency-class-battery-selected           { top: calc( 19px * 3 ); }
  &.active-battery-class-e .efficiency-class-battery-selected           { top: calc( 19px * 4 ); }
  &.active-battery-class-f .efficiency-class-battery-selected           { top: calc( 19px * 5 ); }
  &.active-battery-class-g .efficiency-class-battery-selected           { top: calc( 19px * 6 ); }
}

.efficiency-class {
  height: 16px;
  line-height: 16px;
  margin-bottom: 3px;
  font-size: 0.8125rem;
  padding: 0 3px;
  position: relative;
  color: $white;

  &::after {
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    left: 100%;
    border: 8px solid transparent;
    border-left-width: 10px;
    border-left-color: inherit;
  }
}

.efficiency-class-selected,
.efficiency-class-battery-selected {
  position: absolute;
  top: 0;
  right: 28%;
  width: 10%;
  background-color: #000000;
  border-left-color: #000000;
  text-align: right;

  &::after {
    left: -18px;
    transform: rotate(180deg);
  }
}
.efficiency-class-battery-selected {
  right:5%;
}
.efficiency-a {
  width: 25%;
  background-color: $efficiency-a-color;
  border-left-color: $efficiency-a-color;
}
.efficiency-b {
  width: 30%;
  background-color: $efficiency-b-color;
  border-left-color: $efficiency-b-color;
}
.efficiency-c {
  width: 35%;
  background-color: $efficiency-c-color;
  border-left-color: $efficiency-c-color;
}
.efficiency-d {
  width: 40%;
  background-color: $efficiency-d-color;
  border-left-color: $efficiency-d-color;
}
.efficiency-e {
  width: 45%;
  background-color: $efficiency-e-color;
  border-left-color: $efficiency-e-color;
}
.efficiency-f {
  width: 50%;
  background-color: $efficiency-f-color;
  border-left-color: $efficiency-f-color;
}
.efficiency-g {
  width: 55%;
  margin-bottom: 0;
  border-left-color: $efficiency-g-color;
  background-color: $efficiency-g-color;
}
</style>
